export const artistSubjects = {
  'van-gogh': {
    typical: [
      'sunflowers in a ceramic vase',
      'a starry night sky swirling over a village',
      'wheat fields with cypress trees under cloudy sky',
      'a self-portrait with bandaged ear',
      'a bedroom with simple wooden furniture',
      'almond blossoms on branches'
    ],
    plausible: [
      'a Dutch windmill in autumn with falling leaves',
      'a Parisian street corner at dusk with gas lamps',
      'still life with wine bottles and bread',
      'portrait of a farmer smoking a pipe',
      'a garden path with stone wall and wildflowers',
      'fishing boats moored at a harbor'
    ],
    anachronistic: [
      'a modern city skyline at night with skyscrapers',
      'a laptop computer on a wooden desk',
      'an electric car at a charging station',
      'a smartphone lying on a cafe table',
      'the International Space Station orbiting Earth',
      'a subway train arriving at platform'
    ]
  },
  'cezanne': {
    typical: [
      'red and green apples arranged on a white plate',
      'Mont Sainte-Victoire seen from the valley',
      'card players concentrated on their game',
      'still life with ceramic pitcher and fruit',
      'bathers by a river under trees',
      'a portrait of Madame Cézanne in red dress'
    ],
    plausible: [
      'a Parisian street cafe with patrons',
      'a steam locomotive arriving at station',
      'collection of seashells arranged on cloth',
      'a violin resting on a wooden chair',
      'farmers at a provincial market',
      'a stone bridge over a stream'
    ],
    anachronistic: [
      'neon signs glowing in a city street',
      'a laptop displaying code on screen',
      'a satellite dish on a rooftop',
      'modern kitchen with stainless steel appliances',
      'a video game console with controllers',
      'wind turbines on a hillside'
    ]
  },
  'monet': {
    typical: [
      'water lilies floating on a pond',
      'haystacks at different times of day',
      'Rouen Cathedral facade in morning light',
      'Japanese bridge over a lily pond',
      'woman with parasol in a meadow',
      'poppies blooming in a field'
    ],
    plausible: [
      'fishing boats returning at dawn',
      'interior of Saint-Lazare train station',
      'morning market with vendors and produce',
      'children playing in a park',
      'vineyard in autumn colors',
      'a regatta with white sails'
    ],
    anachronistic: [
      'glass skyscrapers reflecting sunset',
      'electric street lights illuminating rain',
      'solar panel array in a field',
      'helicopter hovering over cityscape',
      'computer server room with blinking lights',
      'traffic on a modern highway at night'
    ]
  },
  'picasso': {
    typical: [
      'a woman weeping with geometric tears',
      'guitar fragmented into angular planes',
      'bull composed of abstract lines',
      'three musicians with cubist instruments',
      'portrait with both profile and frontal views',
      'still life with bottle and newspaper'
    ],
    plausible: [
      'a cafe scene with angular patrons',
      'industrial factory with geometric smokestacks',
      'abstract portrait of a dancer',
      'fragmented view of a train station',
      'circus performers in geometric forms',
      'a typewriter deconstructed into planes'
    ],
    anachronistic: [
      'smartphone screen shattered into fragments',
      'laptop keyboard in cubist perspective',
      'social media icons in geometric abstraction',
      'drone propellers as intersecting circles',
      'QR code integrated into portrait',
      'virtual reality headset on fragmented face'
    ]
  },
  'rembrandt': {
    typical: [
      'self-portrait in dark clothing with golden light',
      'group portrait of cloth guild members',
      'biblical scene with dramatic shadows',
      'anatomy lesson with corpse and observers',
      'elderly man reading by candlelight',
      'woman bathing in golden light'
    ],
    plausible: [
      'merchant counting coins by window light',
      'Dutch kitchen interior with cooking fire',
      'fishermen mending nets in harbor',
      'scholar studying globe and books',
      'blacksmith at forge with sparks',
      'tavern scene with dice players'
    ],
    anachronistic: [
      'surgeon performing operation under LED lights',
      'person illuminated by laptop screen glow',
      'subway commuter checking smartphone',
      'video conference call with multiple faces',
      'photographer with digital camera',
      'DJ at turntables with stage lights'
    ]
  },
  'warhol': {
    typical: [
      'Campbell soup can repeated in grid',
      'Marilyn Monroe in neon colors',
      'dollar signs in repetitive pattern',
      'Elvis Presley with gun drawn',
      'Coca-Cola bottles in series',
      'electric chair in stark silkscreen'
    ],
    plausible: [
      'television sets in pop art grid',
      'telephone repeated in bright colors',
      'typewriter in multiple color schemes',
      'radio in silkscreen repetition',
      'automobile in day-glo colors',
      'cigarette pack in pop art style'
    ],
    anachronistic: [
      'iPhone repeated in rainbow colors',
      'social media logos in pop art grid',
      'Tesla car in neon repetition',
      'Netflix logo screen-printed',
      'AirPods in multiple color ways',
      'cryptocurrency coins in bright series'
    ]
  },
  'hokusai': {
    typical: [
      'The Great Wave with Mount Fuji',
      'Mount Fuji with red summit',
      'koi fish swimming upstream',
      'cherry blossoms over water',
      'samurai in traditional armor',
      'geisha crossing wooden bridge'
    ],
    plausible: [
      'tea ceremony in traditional room',
      'monks walking to temple',
      'merchant ships in Edo harbor',
      'farmers planting rice paddies',
      'festival with paper lanterns',
      'sumo wrestlers in combat'
    ],
    anachronistic: [
      'bullet train passing Mount Fuji',
      'Tokyo Tower in woodblock style',
      'robot in samurai armor',
      'smartphone with manga app',
      'neon signs in Shibuya crossing',
      'astronaut in space with Earth view'
    ]
  },
  'kahlo': {
    typical: [
      'self-portrait with thorn necklace and hummingbird',
      'self-portrait with monkeys and parrots',
      'broken column visible through torn flesh',
      'two Fridas holding hands',
      'Diego on my mind portrait',
      'still life with watermelons'
    ],
    plausible: [
      'Mexican marketplace with vendors',
      'Day of the Dead altar with marigolds',
      'cactus garden with blooming flowers',
      'traditional Mexican kitchen with tiles',
      'revolutionary with rifle and sombrero',
      'indigenous woman weaving textiles'
    ],
    anachronistic: [
      'selfie with smartphone and filters',
      'video call on laptop screen',
      'MRI scan showing spine',
      'drone view of Mexico City',
      'electric scooter with flowers',
      'smart watch on decorated wrist'
    ]
  },
  'turner': {
    typical: [
      'stormy sea with ship in distress',
      'sunset over Venice canal with gondolas',
      'steam train in rain and mist',
      'burning Houses of Parliament',
      'mountain landscape with dramatic light',
      'warship in battle with smoke and fire'
    ],
    plausible: [
      'lighthouse in coastal storm',
      'industrial factory with steam engines',
      'cathedral interior with light rays',
      'harvest scene with golden fields',
      'horse-drawn coach in snowstorm',
      'fishermen hauling nets at dawn'
    ],
    anachronistic: [
      'jet airplane leaving contrails',
      'nuclear power plant with cooling towers',
      'highway interchange at night',
      'wind turbines in misty landscape',
      'city skyline with light pollution',
      'cruise ship in harbor at sunset'
    ]
  },
  'dali': {
    typical: [
      'melting clocks draped over tree branch',
      'elephants with impossibly long legs',
      'distorted self-portrait with mustache',
      'burning giraffe with open drawers',
      'floating objects in desert landscape',
      'crucifixion in geometric space'
    ],
    plausible: [
      'piano suspended in clouds',
      'telephone transforming into lobster',
      'architectural ruins with hidden faces',
      'chess pieces in barren landscape',
      'mirror reflecting impossible scenes',
      'staircase leading to nowhere'
    ],
    anachronistic: [
      'smartphone melting like clock',
      'laptop with liquid screen',
      'DNA double helix as staircase',
      'virtual reality goggles revealing dreams',
      'drone swarm forming surreal shapes',
      'cryptocurrency symbols floating in space'
    ]
  },
  'vermeer': {
    typical: [
      'woman reading letter by window',
      'girl with pearl earring',
      'woman pouring milk in kitchen',
      'music lesson in Dutch interior',
      'view of Delft cityscape',
      'woman with water pitcher'
    ],
    plausible: [
      'merchant examining precious gems',
      'Dutch kitchen with cooking preparations',
      'woman embroidering by candlelight',
      'cartographer with maps and globes',
      'children playing with toys indoors',
      'artist painting in studio'
    ],
    anachronistic: [
      'woman checking smartphone by window',
      'person working on laptop in cafe',
      'video call on computer screen',
      'LED-lit modern kitchen interior',
      'person with tablet device',
      'home office with multiple monitors'
    ]
  },
  'klimt': {
    typical: [
      'The Kiss with gold leaf patterns',
      'portrait of woman in golden dress',
      'Tree of Life with spiraling branches',
      'water serpents in decorative style',
      'embrace with geometric patterns',
      'portrait with Byzantine gold background'
    ],
    plausible: [
      'garden scene with flowering patterns',
      'dancers in ornamental costumes',
      'musicians with decorated instruments',
      'peacock with elaborate plumage',
      'jeweled crown and ornaments',
      'Art Nouveau architectural details'
    ],
    anachronistic: [
      'circuit board patterns in gold',
      'QR code integrated in portrait',
      'holographic fashion design',
      'LED matrix forming figure',
      'augmented reality overlay on face',
      'digital art NFT with gold accents'
    ]
  }
};

export const realArtworks = {
  'van-gogh': [
    'The Starry Night',
    'Sunflowers (Fourth Version)',
    'The Bedroom at Arles',
    'Café Terrace at Night',
    'Irises',
    'Almond Blossoms',
    'The Potato Eaters',
    'Wheat Field with Cypresses',
    'The Mulberry Tree',
    'Portrait of Dr. Gachet'
  ],
  'cezanne': [
    'The Card Players',
    'Still Life with Apples',
    'Mont Sainte-Victoire (1904)',
    'The Bathers (Les Grandes Baigneuses)',
    'The Basket of Apples',
    'Pyramid of Skulls',
    'The Boy in the Red Vest',
    'Houses in Provence',
    'Portrait of Madame Cézanne',
    'Bibémus Quarry'
  ],
  'monet': [
    'Water Lilies (Nymphéas)',
    'Impression, Sunrise',
    'The Japanese Bridge',
    'Haystacks (End of Summer)',
    'Rouen Cathedral (Morning)',
    'Woman with a Parasol',
    'The Water Lily Pond',
    'Poppies',
    'Houses of Parliament (Sunset)',
    'Garden at Sainte-Adresse'
  ],
  'picasso': [
    'Guernica',
    'Les Demoiselles d\'Avignon',
    'The Weeping Woman',
    'Three Musicians',
    'Girl with a Mandolin',
    'The Old Guitarist',
    'Portrait of Dora Maar',
    'Bull\'s Head',
    'Ma Jolie',
    'The Dream'
  ],
  'rembrandt': [
    'The Night Watch',
    'The Anatomy Lesson of Dr. Nicolaes Tulp',
    'Self-Portrait (1669)',
    'The Jewish Bride',
    'The Storm on the Sea of Galilee',
    'Bathsheba at Her Bath',
    'The Return of the Prodigal Son',
    'Portrait of Jan Six',
    'The Syndics',
    'Danaë'
  ],
  'warhol': [
    'Campbell\'s Soup Cans',
    'Marilyn Diptych',
    'Eight Elvises',
    'Gold Marilyn Monroe',
    'Green Coca-Cola Bottles',
    'Electric Chair',
    'Jackie (Four Jackies)',
    'Dollar Sign',
    'Flowers',
    'Mao'
  ],
  'hokusai': [
    'The Great Wave off Kanagawa',
    'Red Fuji (Fine Wind, Clear Morning)',
    'Thunderstorm Beneath the Summit',
    'The Ghost of Oiwa',
    'Phoenix',
    'The Dream of the Fisherman\'s Wife',
    'Waterfall at Yoshino',
    'Cuckoo and Azaleas',
    'Kajikazawa in Kai Province',
    'Feminine Wave'
  ],
  'kahlo': [
    'The Two Fridas',
    'Self-Portrait with Thorn Necklace',
    'The Broken Column',
    'Diego and I',
    'The Wounded Deer',
    'Henry Ford Hospital',
    'Self-Portrait with Cropped Hair',
    'Without Hope',
    'What the Water Gave Me',
    'The Love Embrace of the Universe'
  ],
  'turner': [
    'The Fighting Temeraire',
    'Rain, Steam and Speed',
    'The Burning of the Houses of Lords and Commons',
    'Snow Storm: Hannibal Crossing the Alps',
    'The Blue Rigi',
    'Venice: The Bridge of Sighs',
    'Norham Castle, Sunrise',
    'The Slave Ship',
    'Dido Building Carthage',
    'Modern Rome – Campo Vaccino'
  ],
  'dali': [
    'The Persistence of Memory',
    'The Elephants',
    'Swans Reflecting Elephants',
    'The Burning Giraffe',
    'Christ of Saint John of the Cross',
    'The Temptation of St. Anthony',
    'Galatea of the Spheres',
    'The Disintegration of the Persistence of Memory',
    'Dream Caused by the Flight of a Bee',
    'Soft Construction with Boiled Beans'
  ],
  'vermeer': [
    'Girl with a Pearl Earring',
    'The Milkmaid',
    'View of Delft',
    'The Art of Painting',
    'Woman Reading a Letter',
    'The Music Lesson',
    'Lady Writing a Letter with Her Maid',
    'The Lacemaker',
    'Woman Holding a Balance',
    'The Geographer'
  ],
  'klimt': [
    'The Kiss',
    'Portrait of Adele Bloch-Bauer I',
    'The Tree of Life',
    'Death and Life',
    'Judith and the Head of Holofernes',
    'Water Serpents',
    'The Three Ages of Woman',
    'Danae',
    'Hope II',
    'The Virgin'
  ]
};